<template>
  <modal
    :header-text="$t('modal.unreliablePassword')"
    :button-text="$t('global.save')"
    @action="$emit('save')"
    @close="$emit('close')"
  >
    <div :class="$style.container">
      <div :class="$style.inputContainer">
        {{ $t('modal.savePassword') }}
      </div>
      <ul :class="$style.text">
        <li>{{ $t('modal.strongPassword') }}</li>
        <li>- {{ $t('modal.lengthPassword') }}</li>
        <li>- {{ $t('modal.differentCase') }}</li>
      </ul>
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/control-modal.vue';

  export default {
    components: { Modal },
  };
</script>

<style lang="scss" module>
  .container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
  }
  .inputContainer {
    font-size: 16px;
    text-align: center;
  }
  .text {
    font-size: 11px;
    color: gray;
    display: flex;
    gap: 13px;
    flex-direction: column;
  }
  .button {
    height: 30px;
    cursor: pointer;
    margin: 0px 5px;
    background: #2985bf;
    border: 2px solid #2985bf;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    width: 105px;
  }
</style>
